import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import CardHint from '../../screens/Hint/cardHint';

const HintRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/card`}>
        <CardHint />
      </Route>
    </Switch>
  );
};

export default HintRouter;
